import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo, useEffect, useRef } from 'react';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import ValidationError from 'components/consumer/ValidationError';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import useDebouncedValue from 'hooks/useDebouncedValue';
import { usePrevious } from 'react-use';
import PropTypes from 'prop-types';
const ProductListingWidthRangeFilter = t0 => {
  const $ = _c(42);
  const {
    showTitle: t1
  } = t0;
  const showTitle = t1 === undefined ? false : t1;
  const {
    filters: t2,
    setCustomFilter
  } = useProductListingPageContext();
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const filters = t3;
  let t4;
  if ($[2] !== filters) {
    t4 = filters.find(_temp);
    $[2] = filters;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    minAllowed,
    maxAllowed,
    value: valueInPageState
  } = t4;
  const prevValueInPageState = usePrevious(valueInPageState);
  let t5;
  if ($[4] !== valueInPageState) {
    t5 = valueInPageState?.split("-") ?? [];
    $[4] = valueInPageState;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const arrayValueInPageState = t5;
  let t6;
  if ($[6] !== prevValueInPageState) {
    t6 = prevValueInPageState?.split("-") ?? [];
    $[6] = prevValueInPageState;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const prevArrayValueInPageState = t6;
  const [minValueInPageState, maxValueInPageState] = arrayValueInPageState;
  const [prevMinValueInPageState, prevMaxValueInPageState] = prevArrayValueInPageState;
  const [minimum, setMinimum] = useState(minValueInPageState ?? "");
  const [maximum, setMaximum] = useState(maxValueInPageState ?? "");
  const minNum = parseInt(minimum, 10);
  const maxNum = parseInt(maximum, 10);
  let t7;
  bb0: {
    if (minNum < minAllowed) {
      t7 = `Minimum value cannot be less than ${minAllowed}`;
      break bb0;
    }
    if (minNum > maxAllowed) {
      t7 = `Minimum value cannot be more than ${maxAllowed}`;
      break bb0;
    }
    if (minNum > maxNum) {
      t7 = `Minimum value cannot be greater than ${maxNum}`;
      break bb0;
    }
    t7 = "";
  }
  const minError = t7;
  let t8;
  bb1: {
    if (maxNum < minAllowed) {
      t8 = `Maximum value cannot be less than ${minAllowed}`;
      break bb1;
    }
    if (maxNum > maxAllowed) {
      t8 = `Maximum value cannot be more than ${maxAllowed}`;
      break bb1;
    }
    if (maxNum < minNum) {
      t8 = `Maximum value cannot be less than ${minNum}`;
      break bb1;
    }
    t8 = "";
  }
  const maxError = t8;
  const debouncedMinError = useDebouncedValue(minError, 1000);
  const debouncedMaxError = useDebouncedValue(maxError, 1000);
  let t9;
  if ($[8] !== debouncedMaxError || $[9] !== debouncedMinError) {
    t9 = {
      min: debouncedMinError,
      max: debouncedMaxError
    };
    $[8] = debouncedMaxError;
    $[9] = debouncedMinError;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const widthRangeError = t9;
  let t10;
  let t11;
  if ($[11] !== minValueInPageState || $[12] !== prevMinValueInPageState) {
    t10 = () => {
      setMinimum(latestValue => {
        if (prevMinValueInPageState && !minValueInPageState && !!latestValue && latestValue === prevMinValueInPageState) {
          return "";
        }
        return latestValue;
      });
    };
    t11 = [minValueInPageState, prevMinValueInPageState];
    $[11] = minValueInPageState;
    $[12] = prevMinValueInPageState;
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[15] !== maxValueInPageState || $[16] !== prevMaxValueInPageState) {
    t12 = () => {
      setMaximum(latestValue_0 => {
        if (prevMaxValueInPageState && !maxValueInPageState && !!latestValue_0 && latestValue_0 === prevMaxValueInPageState) {
          return "";
        }
        return latestValue_0;
      });
    };
    t13 = [maxValueInPageState, prevMaxValueInPageState];
    $[15] = maxValueInPageState;
    $[16] = prevMaxValueInPageState;
    $[17] = t12;
    $[18] = t13;
  } else {
    t12 = $[17];
    t13 = $[18];
  }
  useEffect(t12, t13);
  const hasWidthFilterMountedRef = useRef(false);
  let t14;
  let t15;
  if ($[19] !== maximum || $[20] !== minimum || $[21] !== setCustomFilter) {
    t14 = () => {
      if (!hasWidthFilterMountedRef.current) {
        hasWidthFilterMountedRef.current = true;
        return;
      }
      if (!minimum && !maximum) {
        setCustomFilter("widthRange", "");
        return;
      }
      setCustomFilter("widthRange", `${minimum ?? ""}-${maximum ?? ""}`);
    };
    t15 = [maximum, minimum, setCustomFilter];
    $[19] = maximum;
    $[20] = minimum;
    $[21] = setCustomFilter;
    $[22] = t14;
    $[23] = t15;
  } else {
    t14 = $[22];
    t15 = $[23];
  }
  useEffect(t14, t15);
  let t16;
  if ($[24] !== showTitle) {
    t16 = showTitle && <h3 className="text-lg font-bold">Width</h3>;
    $[24] = showTitle;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = event => {
      setMinimum(event?.target?.value);
    };
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== minimum) {
    t18 = <LabeledTextInput variant="range-filter" type="number" name="min" data-xc="min-width-filter-field" label="Min" placeholder="Min" id="min-width" className="first:mr-[5px]" onChange={t17} value={minimum} postfixText="in." noMargin={true} />;
    $[27] = minimum;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = event_0 => {
      setMaximum(event_0?.target?.value);
    };
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== maximum) {
    t20 = <LabeledTextInput variant="range-filter" type="number" name="max" data-xc="max-width-filter-field" label="Max" placeholder="Max" id="max-width" className="last:ml-[5px]" onChange={t19} value={maximum} postfixText="in." noMargin={true} />;
    $[30] = maximum;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t18 || $[33] !== t20) {
    t21 = <div className="flex flex-row items-center justify-between">{t18}{t20}</div>;
    $[32] = t18;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== widthRangeError.max || $[36] !== widthRangeError.min) {
    t22 = (widthRangeError.max || widthRangeError.min) && <ValidationError block={true} data-xc="ProductListingWidthValidationError">{widthRangeError.min || widthRangeError.max}</ValidationError>;
    $[35] = widthRangeError.max;
    $[36] = widthRangeError.min;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t16 || $[39] !== t21 || $[40] !== t22) {
    t23 = <div className="flex flex-col">{t16}{t21}{t22}</div>;
    $[38] = t16;
    $[39] = t21;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  return t23;
};
ProductListingWidthRangeFilter.propTypes = {
  showTitle: PropTypes.bool
};
export default ProductListingWidthRangeFilter;
function _temp(t0) {
  const {
    id
  } = t0;
  return id === "widthRange";
}